import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from 'contexts/AuthContext';
import AddUserModal from './AddUserModal';
import './Dashboard.scss'; // Import shared FAB styles

export default function FloatingUserButton({ onUserAdded }) {
  const { t } = useTranslation();
  const { userRole } = useAuthContext();
  const [showModal, setShowModal] = useState(false);

  // API: YTM=company; huolto=MAINTENANCE; kaivoskäyttäjä=MINE_USER
  const canAddUser = userRole === 1 || userRole === 2 || userRole === 3 || userRole === 4 || userRole === 5;

  if (!canAddUser) {
    return null;
  }

  const handleSuccess = (newUser) => {
    if (onUserAdded) {
      onUserAdded(newUser);
    }
  };

  return (
    <>
      <button
        className="fab"
        onClick={() => setShowModal(true)}
        title={t('fab_add_user')}
        aria-label={t('fab_add_user')}
      >
        <i className="fas fa-plus fa-lg" />
      </button>
      
      <AddUserModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onSuccess={handleSuccess}
      />
    </>
  );
}

